import { toSemverMinor } from './util';

const formJSVersions = {
  'Camunda Cloud': {
    '1.0': '0.0.1',
    '1.1': '0.1.0',
    '1.2': '0.1.0',
    '1.3': '0.1.0',
    '8.0': '0.2.0',
    '8.1': '0.8.0',
    '8.2': '0.14.0',
    '8.3': '1.10.1',
    '8.4': '1.10.1',
    '8.5': '1.10.1',
    '8.6': '1.10.0',
    '8.7': '1.15.0',
    '8.8': '1.15.0'
  },
  'Camunda Platform': {
    '7.15': '0.0.8',
    '7.16': '0.6.0',
    '7.17': '0.7.0',
    '7.18': '0.8.0',
    '7.19': '1.8.7',
    '7.20': '1.8.7',
    '7.21': '1.8.7',
    '7.22': '1.8.7'
  }
};

export function getFormJSVersion(schema) {
  const {
    executionPlatform,
    executionPlatformVersion
  } = schema;

  if (!executionPlatformVersion) {
    return null;
  }

  const executionPlatformVersionMinor = toSemverMinor(executionPlatformVersion);

  if (!formJSVersions[executionPlatform] || !formJSVersions[executionPlatform][executionPlatformVersionMinor]) {
    return null;
  }

  return formJSVersions[executionPlatform][executionPlatformVersionMinor];
}